import { useCallback } from 'react'

import PopinCard from '@/components/Card/PopinCard'
import { useRunnerState } from '@/composables/useRunnerState'

export default function RunnerPopin() {
  const { actor, gameState, persona, scenario, isPopin } = useRunnerState()

  const isOpen = gameState.popin !== null && isPopin

  const onClick = useCallback(() => {
    actor.send({ type: 'CLOSE_POPIN' })
  }, [actor])

  return (
    <PopinCard
      persona={persona}
      scenario={scenario}
      popin={gameState.popin}
      isOpen={isOpen}
      hide={gameState.paused}
      onClose={onClick}
    />
  )
}
